"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPollingConfig = void 0;
const repository_1 = require("../../../../security/authoriser/infra/repositories/checkTrustedVerificationStatus/repository");
const getPollingConfig = (api, progressId, biometricId) => ({
    interval: 5000,
    maxAttempts: 180,
    getDataFn: () => repository_1.trustedVerificationStatusRepository.isVerified(api, progressId, { biometricId }),
});
exports.getPollingConfig = getPollingConfig;
//# sourceMappingURL=polling.helper.js.map